import { Button, Modal } from "react-bootstrap";

export default function FinalizeMissingItemsModal({
  isOpen,
  onClose,
  items,
  message,
  onSelectItem,
  onSelectFirst,
}) {
  const hasItems = Array.isArray(items) && items.length > 0;

  return (
    <Modal show={isOpen} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Cannot Finalize Assessment</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-3">
          {message ||
            "The following required items are missing. Complete them to continue."}
        </p>

        {hasItems ? (
          <div className="d-flex flex-column gap-2">
            {items.map((item, index) => (
              <div
                key={`${item.assessmentId || "missing"}-${item.slug || item.name}-${index}`}
                className="d-flex justify-content-between align-items-center border rounded p-2"
              >
                <div>{item.name || "Missing assessment item"}</div>
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={() => onSelectItem(item)}
                >
                  Go
                </Button>
              </div>
            ))}
          </div>
        ) : (
          <p className="mb-0">No missing assessment items were returned.</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
        {hasItems ? (
          <Button variant="danger" onClick={onSelectFirst}>
            Go to First Missing Item
          </Button>
        ) : null}
      </Modal.Footer>
    </Modal>
  );
}
